import styled, { keyframes } from "styled-components";

const slideIn = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

export const TabsContainer = styled.div`
  .tab-content {
    &.slide-in {
      animation: ${slideIn} 0.3s forwards;
    }

    &.slide-out {
      animation: ${slideOut} 0.3s forwards;
    }
  }

  &.slide-in {
    animation: ${slideIn} 0.3s forwards;
  }

  &.slide-out {
    animation: ${slideOut} 0.3s forwards;
  }
`;

export const TabsToogle = styled.button`
  position: fixed;
  top: 0px;
  left: ${(props) => props.left || "-20px"};
  z-index: 10;
  background: white;
  border: none;
  border-radius: 20px;
  height: 30px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  outline: none;

  &:hover {
    background: #e0e0e0;
    outline: none;
  }

  &:active {
    background: #d0d0d0;
    outline: none;
  }

  &:focus {
    outline: none;
  }
`;

export const CircleButton = styled(TabsToogle)`
  position: initial;
  border: 1px solid rgb(240, 41, 42);
  width: 30px;
  margin-top: 5px;
  box-shadow: none;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FechaBox = styled.div`
  width: ${(props) => props.width || "15%"};
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.5px solid #ccc;
  border-radius: 5px;
  white-space: nowrap;
  margin: 10px 0px;
  flex-direction: column;

  @media (min-width: 1700px) {
    flex-direction: row;
  }
`;

export const FechaBoxText = styled.p`
  font-size: 14px;
  margin: 0px;
  font-weight: 700;
  color: ${(props) => props.colorText || "#293134"};
`;

export const InfoText = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 700;
  margin: 0px;
  color: ${(props) => props.colorText || "#293134"};
  height: fit-content;
`;

export const InfoTextValues = styled.p`
  font-size: 14px;
  font-weight: 500;
  margin-left: 3px;
  color: ${(props) => props.colorText || "#293134"};
  text-align: center;
  margin-bottom: 0;
  /* margin-top: 10px; */
`;

export const InfoTextValuesBold = styled(InfoTextValues)`
  font-weight: 700;
`;
